export const wsStatuses = {
  products: 'SHOW_PRODUCTS',
  payment: 'PROCESS_PAYMENT',
  creating_card: 'CREATING_CARD',
  finished: 'FINISHED',
  error: 'ERROR'
};
